import React from 'react';
import { graphql } from 'gatsby';
import Markdown from 'react-markdown';

import LayoutWrapper from '../components/layout';
import HeroCompact from '../components/hero-compact';
import Section from '../components/Section/Section';
import CSRModule from '../components/CSRModule';
import Clients from '../components/Clients';
import Insights from '../components/insights/Insights';
import Services from '../components/services/Services';
import CTA from '../components/CTA';

import mapQueryResponse from '../utils/mapQueryResponse';
import { getImageUrl } from '../utils/helpers';
import SEO from '../components/SEO';

function Insight({ data }) {
  const {
    strapi: { post, services, posts },
  } = mapQueryResponse(data);

  return (
    <LayoutWrapper>
      <HeroCompact heroCreate={{ title: `${post.title}`, background: post.coverImage }} />
      <Section line>
        <p className='p2'>{post.introduction}</p>
        {Object.values(post.modules).map((module) => {
          switch (module.__typename) {
            case 'Strapi_ComponentModulesTextBlock':
              return (
                <div className='flex flex-col gap-5'>
                  <Markdown>{module.text}</Markdown>
                </div>
              );
            case 'Strapi_ComponentCaseStudyChallengeSolutionResult':
              return <CSRModule csr={module} />;
            case 'Strapi_ComponentModulesImage':
              return module?.media?.hash ? <img src={getImageUrl(module.media.hash)} /> : null;
            default:
              return <hr className='tb__line' />;
          }
        })}
      </Section>
      <CTA
        data={{
          text: `# Looking for **customer service** \n # and expanding your business?`,
          buttonText: 'Contact us',
        }}
      />
      <Section>
        <Services data={services} />
        <Insights insights={posts} />
      </Section>
      <Clients />
    </LayoutWrapper>
  );
}

export const query = graphql`
  query ($id: ID) {
    strapi {
      post(id: $id) {
        data {
          attributes {
            coverImage {
              ...Image
            }
            title
            introduction
            slug
            modules {
              ... on Strapi_ComponentModulesTextBlock {
                __typename
                id
                text
              }
              ... on Strapi_ComponentCaseStudyChallengeSolutionResult {
                __typename
                id
                challengeText
                solutionText
                resultText
                result
                positive
              }
              ... on Strapi_ComponentModulesImage {
                __typename
                id
                media {
                  ...Image
                }
              }
            }
          }
        }
      }
      services {
        ...ServicesList
      }
      posts {
        ...Posts
      }
    }
  }
`;

export default Insight;

export function Head({ data }) {
  const {
    strapi: { post, services, posts },
  } = mapQueryResponse(data);

  return (
    <SEO
      title={post.title}
      description={post?.introduction}
      metaImage={getImageUrl(post.coverImage.hash)}
      pathname={`/insight/${post.slug}`}
      type={'article'}
    />
  );
}
